import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Card, CardTitle, CardText } from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlagIcon from 'material-ui/svg-icons/content/flag';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import { theme } from '../../utils/getTheme';

const CardIcon = styled.div`
  position: absolute;
  top: 16px;
  right: 8px;
`;

class CorporateConnectCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commentModalOpen: false,
      newComment: props.comment,
      newCommentErrorMessage: undefined,
    };
  }

  openCommnetModal = () => {
    this.setState(() => ({
      commentModalOpen: true,
    }));
  };

  closeCommentModal = () => {
    this.setState(() => ({
      commentModalOpen: false,
    }));
  };

  render() {
    const { commentModalOpen, newComment, newCommentErrorMessage } = this.state;
    const {
      corporateId,
      companyName,
      contactEmail,
      contactMobile,
      contactName,
      status,
      comment,
      updateStatus,
      updateComment,
    } = this.props;

    return (
      <div>
        <Card key={corporateId} style={{ position: 'relative' }}>
          <CardTitle
            title={companyName}
            subtitle={`${contactName} | ${contactEmail} | ${contactMobile}`}
            actAsExpander
          />
          <CardIcon>
            <IconButton
              tooltip="Comment"
              onTouchTap={() => {
                this.openCommnetModal();
              }}
            >
              <EditIcon color={theme.primary1Color} />
            </IconButton>
            <IconButton
              onTouchTap={() => {
                updateStatus(corporateId, status);
              }}
              tooltip={status ? 'Reviewed' : 'No reviewed'}
            >
              <FlagIcon
                color={status ? theme.primary1Color : theme.accent1Color}
              />
            </IconButton>
          </CardIcon>
          <CardText expandable>
            {comment === '' ? (
              <div>
                <b>No comment given</b>
              </div>
            ) : (
              <div>
                <b>Comments</b> <br />
                <br />
                {comment}
              </div>
            )}
          </CardText>
        </Card>
        <Dialog
          title="Comment"
          actions={[
            <RaisedButton
              label="Submit"
              primary
              onTouchTap={() => {
                updateComment(corporateId, newComment);
                this.closeCommentModal();
              }}
            />,
            <FlatButton
              label="Close"
              primary
              onTouchTap={() => {
                this.closeCommentModal();
              }}
            />,
          ]}
          open={commentModalOpen}
          onRequestClose={this.closeEditPasswordModal}
        >
          <TextField
            floatingLabelText="Comment"
            multiLine
            fullWidth
            hintText="Feedback for the company"
            value={newComment}
            onChange={(_, value) => {
              this.setState(() => ({
                newComment: value,
              }));
            }}
            errorText={newCommentErrorMessage}
          />
        </Dialog>
      </div>
    );
  }
}

CorporateConnectCard.propTypes = {
  corporateId: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  contactEmail: PropTypes.string.isRequired,
  contactMobile: PropTypes.string.isRequired,
  contactName: PropTypes.string.isRequired,
  status: PropTypes.bool,
  comment: PropTypes.string,
  updateStatus: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
};

CorporateConnectCard.defaultProps = {
  status: false,
  comment: '',
};

export default CorporateConnectCard;



// WEBPACK FOOTER //
// ./src/components/CorporateConnectCard/CorporateConnectCard.js